<mat-icon
  [ngClass]="boolean ? 'green-text margin-top-small' : 'red-text margin-top-small'">{{ boolean ? 'check' : 'do_not_disturb' }}
</mat-icon>
